
export default {
  props: {
    wppost: {
      type: Object,
      required: true,
    },
  },
  head() {
    const image = this.$socialsplash.generate(
      'aad511b1-1b2f-4a97-9bba-4ab9efccd3b5',
      {
        title: this.title,
        image: this.image,
      }
    )

    const metaArray = this.wppost.yoast_meta.map((ele) => {
      const hid = ele.name ? ele.name : ele.property
      switch (hid) {
        case 'robots':
          return {
            hid: 'robots',
            name: 'robots',
            content: ele.content.replace('noindex', 'index'),
          }
        case 'og:url':
          return {
            hid: 'og:url',
            name: 'og:url',
            content: `${this.baseURL}${this.$route.path}`,
          }
        case 'og:image':
          return { hid: 'og:image', name: 'og:image', content: image }
        case 'twitter:image':
          return { hid: 'twitter:image', name: 'twitter:image', content: image }
        case 'og:image:width':
          return {
            hid: 'og:image:width',
            name: 'og:image:width',
            content: '1200',
          }
        case 'og:image:height':
          return {
            hid: 'og:image:height',
            name: 'og:image:height',
            content: '630',
          }
      }

      return {
        hid: ele.name ? ele.name : ele.property,
        name: ele.name ? ele.name : ele.property,
        content: ele.content,
      }
    })

    return {
      title: this.wppost.yoast_title,
      meta: [...metaArray],
      link: [{ rel: 'stylesheet', href: '/print.css', media: 'print' }],
    }
  },
  computed: {
    title() {
      return this.wppost.title.rendered
    },
    excerpt() {
      return this.wppost.excerpt?.rendered?.replace(/(<([^>]+)>)/gi, '')
    },
    image() {
      return this.wppost.featured_image_src.replace(
        'https://api.plantssogood.com',
        'https://ik.imagekit.io/rajumandapati/psg'
      )
    },
    baseURL() {
      return this.$config.baseURL
    },
    category() {
      return this.psgGetParentCategory(this.wppost.categories_extended)
    },
  },
}
